import { createPortal } from 'react-dom';
import React, { Fragment, useState, useEffect, useRef } from 'react';
import {
  withStyles,
  Grid,
  Dialog,
  DialogContent,
  DialogActions,
  Divider,
} from '@material-ui/core';
import Modal from './Modal';
import Error from '../../asset/img/icon_error.svg';
import RadioBtn from '../../asset/img/icon_radio.svg';
import RadioSelBtn from '../../asset/img/icon_radio_sel.svg';
import { FormControl } from '@material-ui/core';
import { RadioGroup } from '@material-ui/core';
import { FormControlLabel } from '@material-ui/core';
import { Radio } from '@material-ui/core';
import Close from '../../asset/img/icon_close.svg';

const styles = (theme) => ({
  root: {
    display: 'flex',
  },
  drawerFrame: {
    borderRadius: '0',
    borderBottomRightRadius: '0',
    borderBottomLeftRadius: '0',
    height: '100%',
    overflowY: 'auto',
    transform: 'none',
    transition: 'transform 225ms cubic-bezier(0, 0, 0.2, 1)',
    position: 'fixed',
    zIndex: '1300',
    inset: '0',
    background: '#fff',
  },
  drawerRoot: {
    display: 'flex',
    flexDirection: 'column',
    overflowY: 'hidden',
  },
  dividerTitle: {
    height: '0.0625rem',
    background: '#000',
    margin: '0rem 0.875rem 1.2188rem 0.875rem',
  },
  titleClose: {
    fontFamily: 'inherit',
    fontSize: theme.font.size18,
    fontWeight: 'bold',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: '1.33',
    letterSpacing: 'normal',
    textAlign: 'left',
    color: '#000',
    padding: '0.0625rem 0rem',
  },
  close: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    '& img': {
      width: '1.5rem',
      height: '1.5rem',
      cursor: 'pointer',
    },
  },
  btnClose: {
    border: 'none',
    background: 'none',
  },
  drawerHeaderClose: {
    position: 'fixed',
    height: '4.375rem',
    background: '#fff',
    width: '100%',
    zIndex: '1',
  },
  closeContainer: {
    display: 'flex',
    minHeight: 'auto',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '0.625rem 1rem',
  },
  modalGridContainer: {
    overflowY: 'auto',
    paddingTop: '4.375rem',
  },
  modalFooter: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: ' 0.875rem 1rem',
    marginTop: '1rem',
    placeContent: 'center',
    borderTop: '0.0625rem solid #ddd',
  },
  modalButtonLeft: {
    paddingRight: '4px',
  },
  modalButtonRight: {
    paddingLeft: '4px',
  },
  modalCancel: {
    width: '100%',
    height: '50px',
    borderRadius: '6px',
    border: 'solid 1px #ddd',
    backgroundColor: '#fff',
    fontFamily: 'NotoSansKR',
    fontSize: '14px',
    fontWeight: 'bold',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: '1.43',
    letterSpacing: 'normal',
    textAlign: 'center',
    color: '#000',
  },
  modalButton: {
    width: '100%',
    height: '50px',
    borderRadius: '6px',
    fontFamily: 'NotoSansKR',
    fontSize: '14px',
    fontWeight: 'bold',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: '1.43',
    letterSpacing: 'normal',
    textAlign: 'center',
  },
  modalConfirm: {
    color: '#fff',
    backgroundColor: '#ea1917', //"#da0f47",
    border: '0',
  },
  modalConfirmDisable: {
    border: '0',
    backgroundColor: '#999',
    color: '#bbb',
  },

  modalButtonDefault: {
    color: '#bbb',
    backgroundColor: '#999',
    border: '0px',
  },
  modalButtonLeft: {
    paddingRight: '0.25rem',
  },
  modalButtonRight: {
    paddingLeft: '0.25rem',
  },
  modalGridItemLabel: {
    padding: '5px 14px 0px 14px',
  },
  modalGridItem: {
    padding: '12px 14px',
  },
  modalLabel: {
    // minHeight: "20px",
    display: 'flex',
    fontFamily: 'NotoSansKR',
    fontSize: theme.font.size14,
    fontWeight: 'bold',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: '1.43',
    letterSpacing: 'normal',
    textAlign: 'left',
    color: '#000',

    '& .star': {
      fontSize: theme.font.size14,
      color: '#ea1917', //"#da0f47"
    },
  },
  star: {
    color: '#ea1917',
  },
  disabledButton: {
    color: 'rgba(38, 38, 38, 0.4)',
  },
  modalField: {
    // paddingTop: "12px",
    '& input': {
      borderRadius: '6px',
      width: '100%',
      height: '46px',
      border: 'solid 1px #929292',
      padding: '13px 16px',
    },
  },
  modalPlainBtn: {
    minHeight: '46px',
    borderRadius: '6px',
    border: 'solid 1px #000',
    backgroundColor: '#fff',
    width: '100%',
    fontFamily: 'inherit',
    fontSize: theme.font.size14,
    fontWeight: 'bold',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: '1.43',
    letterSpacing: 'normal',
    textAlign: 'center',
    color: '#000',
  },
  modalInnerItem: {
    padding: '0px',
    paddingRight: '8px',
  },
  modalInnerItemLast: {
    paddingRight: '0px',
  },
  infoIcon: {
    width: '16px',
    height: '16px',
  },
  textareaField: {
    position: 'relative',
  },
  textarea: {
    width: '100%',
    height: '150px',
    borderRadius: '6px',
    background: '#fff',
    font: 'inherit',
    fontSize: '14px',
    padding: '13px 16px 35px',
    resize: 'none',
    '&::placeholder': {
      color: theme.color.input.placeholder,
    },
  },
  textCount: {
    font: 'inherit',
    fontSize: '12px',
    letterSpacing: 'normal',
    position: 'absolute',
    bottom: '14px',
    right: '16px',
  },
  nextLine: {
    paddingBottom: 0,
  },
  disabled: {
    background: '#ededed',
    border: '0px !important',
  },
  showAll: {
    fontWeight: 'bold',
    fontSize: theme.font.size12,
    letterSpacing: 'normal',
    textDecoration: 'underline',
    // cursor: 'pointer',
    background: 'none',
    border: 'none',
    color: '#000',
  },
  terms: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  termTextArea: {
    height: '120px',
    overflowY: 'auto',
    border: '1px solid #929292',
    borderRadius: '6px 6px 0 0',
    fontSize: theme.font.size12,
    padding: '16px',
    lineHeight: '18px',
  },
  termTextTitle: {
    fontWeight: 'bold',
  },
  checkArea: {
    height: '48px',
    border: '1px solid #929292',
    borderTop: 'none',
    borderRadius: '0 0 6px 6px',
    fontSize: theme.font.size12,
    display: 'flex',
    alignItems: 'center',
    padding: '16px',
    '& label': {
      width: '100%',
      display: 'flex',
      alignItems: 'center',
      fontSize: theme.font.size14,
      fontWeight: 'bold',
    },
    '& input': {
      height: '20px',
      width: '20px',
      marginRight: '6px !important',
    },
    '& input.error': {},
  },
  errorIcon: {
    width: '12px',
    height: '12px',
    color: '#ff3723',
    marginRight: '3px',
  },
  errorText: {
    color: '#ff3723',
    fontSize: theme.font.size13,
    display: 'flex',
    alignItems: 'center',
    paddingTop: '8px',
  },
  dialogRoot: {
    borderRadius: '0.625rem',
    width: '90%',
    maxWidth: '37.5rem',
  },
  dialogContent: {
    fontFamily: 'inherit',
    fontSize: theme.font.size16,
    fontWeight: 'bold',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: '1.38',
    letterSpacing: 'normal',
    textAlign: 'center',
    color: '#000',
    padding: '40px 20px 15px !important',
  },
  dialogFooter: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'cneter',
    padding: '15px',
    '& button': {
      height: '50px',
      width: '50%',
      borderRadius: '6px',
      border: 'solid 1px #ea1917', //"solid 1px #da0f47",
      fontFamily: 'inherit',
      fontSize: theme.font.size14,
      fontWeight: 'bold',
      fontStretch: 'normal',
      fontStyle: 'normal',
      lineHeight: '1.43',
      letterSpacing: 'normal',
      textAlign: 'center',
    },
  },
  dialogFooterBtnLeft: {
    background: '#fff',
    color: '#000',
    border: 'solid 0.0625rem #ddd !important',
  },
  dialogFooterBtnRight: {
    background: '#ea1917', //"#da0f47",
    color: '#fff',
  },
  textareaSentence: {
    fontSize: theme.font.size13,
  },
});

function CustUrge(props) {
  const { classes, data, modalOpen, modalClose, handleButtonClick } = props;
  const [closeDialogOpen, setCloseDialogOpen] = useState(false);

  // const Input = withStyles(styles)((props) => {
  //   const { classes, text, placeholder, errorText = placeholder } = props;
  //   return (
  //     <Fragment>
  //       <input type="text" placeholder={placeholder} className={classes.error} />
  //       <div className={classes.errorText}>
  //         <img src={Error} className={classes.errorIcon} alt="입력/수정 필요" />
  //         {errorText}
  //       </div>
  //     </Fragment>
  //   );
  // });

  const modalRef = useRef();

  useEffect(() => {
    if (modalOpen) {
      // 웹접근성 - 모달팝업 포커스 25-01
      const { current: modalElement } = modalRef;
      window.setTimeout(() => {
        modalElement.focus();
      });
    }
  }, [modalOpen]);

  const handleCancel = () => {
    console.log('[Cancel clicked] 취소');

    setCloseDialogOpen(false);
    handleButtonClick(false, '', data.item, data.button, '그만하기');

    const rootChild = document.getElementById('root');
    const focusableElements = rootChild.querySelectorAll('*');

    for (let i = 0; i < focusableElements.length; i++) {
      focusableElements[i].removeAttribute('aria-hidden');
    }
    // modalClose();
  };

  const [custUrge, setCustUrge] = useState('');
  const [textCount, setTextCount] = useState(0);

  const handleChange = (event) => {
    // console.log('[handlechange] value', event.target.value);
    // console.log('[handlechange] name', event.target.name);

    setCustUrge(event.target.value);
    setTextCount(event.target.value.length);
  };

  const handleSubmit = () => {
    console.log('[handleSubmit] custUrge', custUrge);

    handleButtonClick(true, custUrge, data.item, data.button, '완료');

    const rootChild = document.getElementById('root');
    const focusableElements = rootChild.querySelectorAll('*');

    for (let i = 0; i < focusableElements.length; i++) {
      focusableElements[i].removeAttribute('aria-hidden');
    }
    // modalClose();
  };

  return createPortal(
    <div className={classes.root}>
      {/* <Modal
        component={withStyles(styles)(CustUrgeModal)}
        anchor="bottom"
        title="서비스매니저에게 요청하기"
        data={data}
        modalOpen={modalOpen}
        modalClose={modalClose}
        customClose={() => setCloseDialogOpen(true)}
        height="100%"
        borderRadius="0px"
        closeType="close"
      /> */}
      {modalOpen && (
        <div className={classes.drawerFrame}>
          <div className={classes.drawerRoot}>
            <div className={classes.drawerHeaderClose}>
              <div className={classes.closeContainer}>
                <div className={classes.titleClose} ref={modalRef} tabIndex="0">
                  서비스매니저에게 요청하기
                </div>
                <div className={classes.close}>
                  <button className={classes.btnClose} onClick={modalClose}>
                    <img src={Close} className={classes.arrowDown} alt="닫기" />
                  </button>
                </div>
              </div>
              <Divider classes={{ root: classes.dividerTitle }} />
            </div>
            <Fragment>
              <Grid container className={classes.modalGridContainer}>
                {/* 서비스매니저에게 요청하기 */}
                <Grid
                  item
                  xs={12}
                  className={[
                    classes.modalGridItemLabel,
                    classes.modalGridItemLabelFirst,
                  ].join(' ')}
                >
                  <div className={classes.modalLabel}>
                    요청사항<em className={classes.star}>*</em>
                  </div>
                </Grid>

                {/* 요청사항 */}
                <Grid item xs={12} className={classes.modalGridItem}>
                  <div className={[classes.modalField, classes.textareaField].join(' ')}>
                    <label for="textareaUrgeDesc" hidden>
                      요청사항
                    </label>
                    <textarea
                      id="textareaUrgeDesc"
                      className={classes.textarea}
                      placeholder="서비스 매니저에게 전달할 내용이 있다면 입력해 주세요. 개인정보 보호를 위해 주민등록번호, 휴대폰 번호 등 민감정보는 입력하지 않도록 유의해 주세요."
                      name="urgeDesc"
                      onChange={handleChange}
                      value={custUrge}
                      maxLength={50}
                    />
                    <span className={classes.textCount}>{textCount}/50자</span>
                  </div>
                  <div className={classes.textareaSentence}>
                    · 전달사항 입력란에 개인정보 보호를 위해 주민등록번호, 휴대폰 번호 등
                    민감정보는 입력하지 않도록 유의해 주세요.
                    <br />
                    · 입력하신 정보가 정확하지 않을 경우 서비스가 취소 또는 지연될 수
                    있습니다.
                    <br />· 도서(섬) 지역의 경우 관계법령에 따라 일부 서비스(용접 수리,
                    냉매 보충 등)가 제한될 수 있습니다.
                  </div>
                </Grid>
              </Grid>

              {/* footer button */}
              <Grid container className={classes.modalFooter}>
                <Grid item xs={6} className={classes.modalButtonLeft}>
                  <button
                    className={classes.modalCancel}
                    onClick={() => {
                      setCloseDialogOpen(true);
                    }}
                  >
                    취소
                  </button>
                </Grid>
                <Grid item xs={6} className={classes.modalButtonRight}>
                  <button
                    disabled={custUrge === ''}
                    className={[
                      classes.modalButton,
                      custUrge === ''
                        ? classes.modalConfirmDisable
                        : classes.modalConfirm,
                    ].join(' ')}
                    onClick={handleSubmit}
                  >
                    완료
                  </button>
                </Grid>
              </Grid>
            </Fragment>
          </div>
        </div>
      )}
      <Dialog
        open={closeDialogOpen}
        onClose={() => setCloseDialogOpen(false)}
        classes={{ paper: classes.dialogRoot }}
      >
        <DialogContent classes={{ root: classes.dialogContent }}>
          지금 종료하시면 입력하신 <br />
          정보가 사라져요. 그만하시겠어요?
        </DialogContent>
        <DialogActions classes={{ root: classes.dialogFooter }}>
          <button className={classes.dialogFooterBtnLeft} onClick={() => handleCancel()}>
            그만하기
          </button>
          <button
            className={classes.dialogFooterBtnRight}
            onClick={() => setCloseDialogOpen(false)}
            autoFocus
          >
            계속하기
          </button>
        </DialogActions>
      </Dialog>
    </div>,
    document.getElementById('modal')
  );
}
export default withStyles(styles)(CustUrge);
